import { render, staticRenderFns } from "./FaenaMortalidad.vue?vue&type=template&id=948332ba"
import script from "./FaenaMortalidad.vue?vue&type=script&lang=js"
export * from "./FaenaMortalidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports